import React from "react";
import Head from "next/head";

import { AppStoreBadge, PlayStoreBadge } from "@component/badges";
import Nav from "@component/layout/nav";

import mobileUser from "./mobile_user.png";

import styles from "./styles.module.scss";

function DownloadPage() {
  return (
    <>
      <Head>
        <title>Kikoff Credit Building App</title>
        <meta
          name="description"
          content="Check out the newly updated Kikoff mobile app!"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://kikoff.com/download" />
      </Head>
      <Nav />
      <div className={styles["download-page"]}>
        <header
          className={`text:heading-2 ${styles["download-title"]}`}
          data-cy="download-blurb"
        >
          Check out the newly updated Kikoff mobile app!
        </header>
        <div className={styles["mobile-app-user-wrapper"]}>
          <img
            alt="relaxed Kikoff app user"
            className={styles["mobile-app-user"]}
            src={mobileUser.src}
          />
        </div>
        <div className={styles["badge-wrapper"]}>
          <AppStoreBadge />
          <PlayStoreBadge />
        </div>
      </div>
    </>
  );
}

export default DownloadPage;
